import { render, staticRenderFns } from "./setTable.vue?vue&type=template&id=513c2f1e&scoped=true"
import script from "./setTable.vue?vue&type=script&lang=js"
export * from "./setTable.vue?vue&type=script&lang=js"
import style0 from "./setTable.vue?vue&type=style&index=0&id=513c2f1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c2f1e",
  null
  
)

export default component.exports